"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsToManyList = exports.AsClass = void 0;
const base_models_1 = require("./models/base-models");
function AsClass(_target) {
    const f = function (proto, fieldName, descriptor) {
        var target = proto.constructor;
        if (!target.__postCast) {
            // create list of fields to cast
            target.__postCast = {};
            // preserve the methods actual setter
            target.__actualSet = proto.set;
            // give class new setter that casts
            proto.set = function (a) {
                // do old setting
                var v = target.__actualSet.bind(this)(a);
                // then go through registered castTypes
                Object.keys(target.__postCast).filter(i => a[i]).forEach(i => {
                    let suppliedObj = a[i];
                    let clazz = target.__postCast[i];
                    let className = this.vasat.classNameForType(clazz);
                    if (suppliedObj instanceof clazz) {
                        this[i] = suppliedObj;
                    }
                    else {
                        this[i] = this.vasat.findCached(className, suppliedObj) || new clazz(this.vasat).set({ id: suppliedObj });
                    }
                });
                return v;
            };
        }
        // add this type to cast list
        target.__postCast[fieldName] = _target;
        return descriptor;
    };
    return f;
}
exports.AsClass = AsClass;
function AsToManyList(_target) {
    const f = function (proto, fieldName, descriptor) {
        if (!proto.__manyToManys) {
            // create list of fields to cast
            proto.__manyToManys = {};
            // preserve the methods actual setter
            proto.__actualInit = proto.setVals;
            proto.setVals = function (a) {
                var v = this.__actualInit.bind(this)(a);
                Object.keys(this.__manyToManys).forEach(m => this[m] = new base_models_1.ToManyList(proto.__manyToManys[m], this, m));
            };
        }
        proto.__manyToManys[fieldName] = _target;
    };
    return f;
}
exports.AsToManyList = AsToManyList;
